/*
 *
 * MailConfiguration reducer
 *
 */

import { fromJS } from "immutable"
import {
  GET_CONFIGURATION_WATCHER,
  GET_CONFIGURATION_SUCCESS,
  GET_CONFIGURATION_FAILED,
  GET_IMAGE_LOGO_WATCHER,
  GET_IMAGE_LOGO_SUCCESS,
  GET_IMAGE_LOGO_FAILED,
} from "./constants"

export const initialState = fromJS({
  configuration: {},
  isLoadingConfiguration: true,
  images: {},
  isLoadingImages: true,
  logo: {},
  isLoadingLogo: true,
})

function mailConfigurationReducer(state = initialState, action) {
  switch (action.type) {
    case GET_IMAGE_LOGO_WATCHER:
      if (action.payload.type === "image") {
        return (
          state
            // .set('images', {})
            .set("isLoadingImages", true)
        )
      }

      return (
        state
          // .set('logo', {})
          .set("isLoadingLogo", true)
      )

    case GET_IMAGE_LOGO_SUCCESS:
      if (action.payload.type === "image") {
        return state.set("images", action.payload).set("isLoadingImages", false)
      }

      return state.set("logo", action.payload).set("isLoadingLogo", false)

    case GET_IMAGE_LOGO_FAILED:
      if (action.payload.type === "image") {
        return state.set("isLoadingImages", false)
      }

      return state.set("isLoadingLogo", false)

    case GET_CONFIGURATION_WATCHER:
      return state.set("configuration", {}).set("isLoadingConfiguration", true)

    case GET_CONFIGURATION_SUCCESS:
      return state
        .set("configuration", action.payload)
        .set("isLoadingConfiguration", false)

    case GET_CONFIGURATION_FAILED:
      return state.set("configuration", {}).set("isLoadingConfiguration", false)

    default:
      return state
  }
}

export default mailConfigurationReducer
